<template> 
  <b-modal ref="modal" :title="coupon.id ? `Edit Coupon ${coupon.id}` : 'Create Coupon'" lazy>
    <b-form @submit.prevent="submit">
      <validation-summary :errors="errors"></validation-summary>

      <b-form-group>
        <b-form-checkbox v-model="coupon.isActive">Active</b-form-checkbox>
      </b-form-group>

      <v-form-group :validator="$v.coupon.code" label="Code">
        <b-form-input v-model="coupon.code"
                      placeholder="Code"
                      slot-scope="{ attrs, listeners }"
                      v-bind="attrs"
                      v-on="listeners" />
      </v-form-group>

      <b-form-group class="form-group-radio" label="Type">
        <b-form-radio v-model="coupon.type" :value="couponType.Amount">Amount off</b-form-radio>
        <b-form-radio v-model="coupon.type" :value="couponType.Percent">Percent off</b-form-radio>
      </b-form-group>

      <v-form-group :validator="$v.coupon.value" :label="coupon.type == couponType.Amount ? 'Amount' : 'Percent'">
        <form-input-formatted v-if="coupon.type == couponType.Amount"
                              type="money"
                              v-model="coupon.value"
                              placeholder="Amount" />

        <form-input-formatted v-if="coupon.type == couponType.Percent"
                              type="percent"
                              v-model="coupon.value"
                              placeholder="Percent" />
      </v-form-group>
    </b-form>
    <div slot="modal-footer">
      <b-btn @click="cancel" variant="outline-secondary">Cancel</b-btn>
      <b-btn :loading="loading" variant="success" @click="submit">
        {{ coupon.id ? 'Edit' : 'Create' }}
      </b-btn>
    </div>
  </b-modal>
</template>

<script>
  import { required } from 'vuelidate/lib/validators';

  import { createNamespacedHelpers } from 'vuex';
  const { mapActions, mapState } = createNamespacedHelpers('coupon');

  import couponType from "enums/coupon-type";

  import modalFormMixin from 'mixins/modal-form-mixin';

  export default {
    mixins: [modalFormMixin],

    data() {
      return {
        couponType
      }
    },

    validations: {
      coupon: {
        code: {
          required
        },
        value: {
          required
        }
      }
    },

    computed: {
      ...mapState(['coupon'])
    },

    methods: {
      ...mapActions(['loadCoupon', 'saveCoupon']),

      async beforeShow(id) {
        await this.loadCoupon(id);
      },

      async onSubmit() {
        await this.saveCoupon();
      }
    }
  }

</script>